module.exports = __webpack_public_path__ + "media/images/article-093117edad936cf23c4bc27fc293b025.png";